import React, { useState, useEffect } from 'react';
import { scrollToTop } from '../utils/scrollUtils';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Throttle function for performance optimization
  const throttle = (func, limit) => {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  };

  // Handle scroll events with throttling
  const handleScroll = throttle(() => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    setIsVisible(scrollTop > 300);
  }, 100);

  useEffect(() => {
    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);
    
    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  const handleClick = () => {
    scrollToTop('smooth');
  };

  return (
    <button
      onClick={handleClick}
      className={`
        fixed bottom-8 right-8 z-[999]
        w-12 h-12 rounded-full
        bg-gradient-to-br from-indigo-500 to-purple-600
        text-white font-semibold
        shadow-lg hover:shadow-xl
        transition-all duration-300 ease-in-out
        hover:-translate-y-0.5 hover:scale-105
        focus:outline-none focus:ring-4 focus:ring-indigo-300 focus:ring-opacity-50
        flex items-center justify-center
        group
        ${isVisible 
          ? 'opacity-100 translate-y-0 pointer-events-auto' 
          : 'opacity-0 translate-y-4 pointer-events-none'
        }
      `}
      aria-label="Scroll to top"
      title="Scroll to top"
    >
      {/* Up Arrow Icon */}
      <svg 
        className="w-5 h-5 transition-transform duration-200 group-hover:-translate-y-0.5" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
        strokeWidth={2.5}
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          d="M5 15l7-7 7 7" 
        />
      </svg>
      
      {/* Hover glow effect */}
      <div className="absolute inset-0 rounded-full bg-gradient-to-br from-indigo-400 to-purple-500 opacity-0 group-hover:opacity-20 transition-opacity duration-300 blur-sm"></div>
    </button>
  );
};

export default ScrollToTopButton;